<template>
	<div id="main" class="column is-9">
		<Schedule :id="id" />
	</div>
</template>

<script>
	import Schedule from "../shared/Schedule.vue"

	export default {
		components: {
			Schedule
		},	
		data() {
			return {
				id: JSON.parse(localStorage.getItem("user")).user_id.toString()
			}
		}
	}
</script>